import { Responsive, WidthProvider } from 'react-grid-layout';

export const ResponsiveGridLayout = WidthProvider(Responsive);
